module.exports = __webpack_public_path__ + "img/30.f018e4b4.jpg";